/* unplugin-vue-components disabled */import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
var _hoisted_1 = {
  "class": "content"
};
var _hoisted_2 = {
  "class": "about-item-left"
};
var _hoisted_3 = {
  "class": "item-text"
};
var _hoisted_4 = {
  "class": "zy_conts"
};
var _hoisted_5 = {
  "class": "item"
};
var _hoisted_6 = {
  "class": "cont_pic"
};
var _hoisted_7 = ["src"];
var _hoisted_8 = {
  "class": "cont_r"
};
var _hoisted_9 = ["textContent"];
var _hoisted_10 = {
  "class": "contact"
};
import { collegesListApi } from "../../api/work/work";
import { cloneDeep } from 'lodash';
export default /*@__PURE__*/_defineComponent({
  __name: 'School',
  setup: function setup(__props) {
    var collegesData = ref([]);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res, _cloneDeep;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return collegesListApi();
          case 2:
            res = _context.sent;
            if (res.code === 200) {
              collegesData.value = (_cloneDeep = cloneDeep(res.data)) !== null && _cloneDeep !== void 0 ? _cloneDeep : [];
            } else {
              ElMessage.error(res.msg);
            }
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(collegesData), function (item) {
        return _openBlock(), _createElementBlock("div", {
          "class": "about-item",
          key: item.name
        }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
          src: item.image
        }, null, 8, _hoisted_7)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_createElementVNode("h5", {
          textContent: _toDisplayString(item.name)
        }, null, 8, _hoisted_9), _createElementVNode("p", null, "英文名称：" + _toDisplayString(item.officeHours), 1), _createElementVNode("p", null, "学校地址：" + _toDisplayString(item.tel), 1)]), _createElementVNode("span", _hoisted_10, "合作内容：" + _toDisplayString(item.address), 1)])])])])])]);
      }), 128))]);
    };
  }
});